import { render, staticRenderFns } from "./TheContact.vue?vue&type=template&id=cd4c70e6&scoped=true"
import script from "./TheContact.vue?vue&type=script&lang=js"
export * from "./TheContact.vue?vue&type=script&lang=js"
import style0 from "./TheContact.vue?vue&type=style&index=0&id=cd4c70e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4c70e6",
  null
  
)

export default component.exports